import { Fragment } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { Check as CheckIcon, ChevronUpDown as ChevronUpDownIcon } from 'components/icons/outline'

const Select = ({ selection = [], value, placeholder, keyValue, display, onChange, error }) => {
    // `selected` murni derived dari prop `value` + `selection` — tidak ada internal state,
    // sehingga ketika opsi async terload belakangan, label otomatis ikut update tanpa
    // memicu onChange spurious yang justru meng-clear nilai parent.
    const selected = (value != null ? selection?.find(row => row[keyValue] === value) : null) ?? {}
    const isEmpty = Object.keys(selected).length === 0

    const handleSelect = (row) => {
        onChange?.(row?.[keyValue] ?? null)
    }

    return (
        <Listbox value={selected} onChange={handleSelect}>
            <div className="relative mt-1">
                <Listbox.Button className={`${error ? 'border-red-200' : 'border-neutral-200'} w-full px-4 py-2 text-sm text-left transition border focus:outline-none rounded-xl focus:border-neutral-400 focus:ring focus:ring-neutral-200`}>
                    <span className={`${isEmpty ? 'text-neutral-400' : ''} block truncate`}>
                        {selected?.[display] ?? placeholder}
                    </span>
                    <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <ChevronUpDownIcon
                            className="w-5 h-5 text-neutral-400"
                            aria-hidden="true"
                        />
                    </span>
                </Listbox.Button>
                <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white border rounded-xl max-h-60 border-neutral-200 focus:outline-none sm:text-sm">
                        {selection?.map((row, index) => (
                            <Listbox.Option
                                key={index}
                                className={({ active }) =>
                                    `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-amber-100 text-amber-900' : 'text-neutral-900'
                                    }`
                                }
                                value={row}
                            >
                                {({ selected }) => (
                                    <>
                                        <span
                                            className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                }`}
                                        >
                                            {row[display]}
                                        </span>
                                        {selected ? (
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                <CheckIcon className="w-5 h-5" aria-hidden="true" />
                                            </span>
                                        ) : null}
                                    </>
                                )}
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </Transition>
            </div>
        </Listbox>
    )
}

export default Select